var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconContact(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 260,
    height: 260,
    viewBox: "0 0 260 260",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 1995"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 1778-2",
    fill: "none",
    d: "M0 0h260v260H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "target",
    "data-name": "\\u30D1\\u30B9 1094",
    d: "M196.223 60.001H63.78A24.835 24.835 0 0 0 39.003 84.84v90.322a24.836 24.836 0 0 0 24.777 24.839h132.443a24.837 24.837 0 0 0 24.78-24.838V84.84a24.837 24.837 0 0 0-24.78-24.839ZM63.78 73.549h132.443a11.29 11.29 0 0 1 11.262 11.291v11.617l-75.94 38.928a3.347 3.347 0 0 1-3.085 0L52.518 96.456V84.84A11.289 11.289 0 0 1 63.78 73.549Zm132.443 112.9H63.78a11.289 11.289 0 0 1-11.262-11.29v-63.49l69.789 35.775a16.918 16.918 0 0 0 15.391 0l69.787-35.775v63.489a11.29 11.29 0 0 1-11.262 11.295Z",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContact);
export default __webpack_public_path__ + "static/media/icon_contact.405595c5ae3779a12e2a0ffe831cc9a4.svg";
export { ForwardRef as ReactComponent };